// LIVE-06 巡航：在預置點之間輪流停留。由瀏覽器驅動（每到時間送一次 preset_goto，順便續 PTZ lease）——
// 關掉瀏覽器 / 收起控制盤 / 被搶控 / 手動操作都會停，攝影機停在最後一個預置點。

export const CRUISE_DWELL_MIN = 5;
export const CRUISE_DWELL_MAX = 120;
export const CRUISE_DWELL_DEFAULT = 15;

export function clampDwell(s: number): number {
  if (!Number.isFinite(s)) return CRUISE_DWELL_DEFAULT;
  return Math.min(CRUISE_DWELL_MAX, Math.max(CRUISE_DWELL_MIN, Math.round(s)));
}

/** 能不能巡航：至少兩個預置點。 */
export function canCruise(presets: { token: string }[] | null | undefined): boolean {
  return (presets?.length ?? 0) >= 2;
}

/** 下一個預置點（繞回第一個）；目前的不在清單裡（被刪了）就從頭。 */
export function nextPreset<T extends { token: string }>(presets: T[], current: string | null): T | null {
  if (!presets.length) return null;
  const i = presets.findIndex((p) => p.token === current);
  return presets[(i + 1) % presets.length];
}
